import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import HomeStappenPlan from '../components/Home/HomeStappenPlan'
import HomeProjectList from '../components/Home/HomeProjectList'
import HomeWie from '../components/Home/HomeWie'
import HomeMeerInfo from '../components/Home/HomeMeerInfo'

import favicon16 from '../img/bijn-favicon-16.png'
import favicon32 from '../img/bijn-favicon-32.png'
import favicon64 from '../img/bijn-favicon-64.png'
import '../components/all.sass'

const IndexPage = ({ data }) => {
  const { title: sitename } = data.site.siteMetadata
  const { edges: posts } = data.allWordpressWpProject
  const { featured_media: homeWieImg } = data.home

  const {
    home_intro: homeIntro,
    home_intro_title: homeIntroTitle,
    home_foto_credits: homeWieCredits,
    home_foto_credits_link: homeWieCreditsLink,
    home_stap_1_title: homeStap1Titel,
    home_stap_1_text: homeStap1Tekst,
    home_stap_2_title: homeStap2Titel,
    home_stap_2_text: homeStap2Tekst,
    home_stap_3_title: homeStap3Titel,
    home_stap_3_text: homeStap3Tekst,
    home_stap_4_title: homeStap4Titel,
    home_stap_4_text: homeStap4Tekst,
    home_outro: homeOutro,
    home_outro_button_text: homeOutroBtnTekst,
    home_wie_intro: homeWieIntro,
    home_wie_sub: homeWieSub,
    home_wie_button_text: homeWieBtnTekst,
    home_minfo_1_title: homeMI1title,
    home_minfo_1_text: homeMI1text,
    home_minfo_1_btn_text: homeMI1btnText,
    home_minfo_2_title: homeMI2title,
    home_minfo_2_text: homeMI2text,
    home_minfo_2_btn_text: homeMI2btnText,
    home_minfo_3_title: homeMI3title,
    home_minfo_3_text: homeMI3text,
    home_minfo_3_btn_text: homeMI3btnText,
    meta_description: metadesc,
    meta_tags: metatags,
  } = data.home.acf

  return (
    <Layout>
      <>
        <Helmet>
          <title>{`Energetisch renoveren - interieuradvies - totaalinrichting | ${sitename}`}</title>
          <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
          <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
          <link
            rel="shortcut icon"
            type="image/png"
            sizes="64x64"
            href={favicon64}
          />
          {metadesc ? <meta name="description" content={metadesc} /> : null}
          {metatags ? <meta name="keywords" content={metatags} /> : null}
        </Helmet>
        <HomeStappenPlan
          homeIntro={homeIntro}
          homeIntroTitle={homeIntroTitle}
          homeStap1Titel={homeStap1Titel}
          homeStap1Tekst={homeStap1Tekst}
          homeStap2Titel={homeStap2Titel}
          homeStap2Tekst={homeStap2Tekst}
          homeStap3Titel={homeStap3Titel}
          homeStap3Tekst={homeStap3Tekst}
          homeStap4Titel={homeStap4Titel}
          homeStap4Tekst={homeStap4Tekst}
          homeOutro={homeOutro}
          homeOutroBtnTekst={homeOutroBtnTekst}
        />
        <HomeProjectList posts={posts} />
        <HomeWie
          homeWieImg={homeWieImg}
          homeWieCredits={homeWieCredits}
          homeWieCreditsLink={homeWieCreditsLink}
          homeWieIntro={homeWieIntro}
          homeWieSub={homeWieSub}
          homeWieBtnTekst={homeWieBtnTekst}
        />
        <HomeMeerInfo
          homeMI1title={homeMI1title}
          homeMI1text={homeMI1text}
          homeMI1btnText={homeMI1btnText}
          homeMI2title={homeMI2title}
          homeMI2text={homeMI2text}
          homeMI2btnText={homeMI2btnText}
          homeMI3title={homeMI3title}
          homeMI3text={homeMI3text}
          homeMI3btnText={homeMI3btnText}
        />
      </>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPage {
    site {
      siteMetadata {
        title
      }
    }
    allWordpressWpProject(limit: 3) {
      edges {
        node {
          ...ProjectListFields
        }
      }
    }
    home: wordpressPage(wordpress_id: { eq: 250 }) {
      featured_media {
        alt_text
        title
        localFile {
          childImageSharp {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      acf {
        home_intro_title
        home_intro
        home_foto_credits
        home_foto_credits_link
        home_stap_1_title
        home_stap_1_text
        home_stap_2_title
        home_stap_2_text
        home_stap_3_title
        home_stap_3_text
        home_stap_4_title
        home_stap_4_text
        home_outro
        home_outro_button_text
        home_wie_intro
        home_wie_sub
        home_wie_button_text
        home_minfo_1_title
        home_minfo_1_text
        home_minfo_1_btn_text
        home_minfo_2_title
        home_minfo_2_text
        home_minfo_2_btn_text
        home_minfo_3_title
        home_minfo_3_text
        home_minfo_3_btn_text
        meta_description
        meta_tags
      }
    }
  }
`
